import { Box, styled } from '@mui/material';

const ActionsWrapper = styled(Box)`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export default ActionsWrapper;
